import { Component, ElementRef, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { OilRecoveryService } from 'src/app/services/customers/oil-recovery.service';
import { ClientsService } from '../../../services/customers/clients.service';
import { OilRecoveryModel } from 'src/app/models/customers/oil-recovery.model';

// Tier 6: removed Wijmo imports — `CellMaker`, `CollectionView`, `* as wjcGrid`,
// `* as wjcCore`, `* as wjcInput`, `* as wjcGridXlsx` are no longer needed. The
// grid is now AG Grid via the wrapper; clicks are routed through
// `(cellClicked)`. The XLSX export is replaced with a feedback info stub.

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { UpdatedModelUtilities } from 'src/app/utilities/updated.model.utilities';
import { ToastrService } from 'ngx-toastr';
import { PdfUtilities } from '../../../utilities/pdf/pdf.utilities';
import { Calculates } from '../../../utilities/calculateWaste';

import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import { ZapierService } from '../../../services/helpers/zapier.service';
import { EmailTemplate } from '../../../constants/email-template';
import { PdfMakeWrapper } from 'pdfmake-wrapper';
import { UsuarioService } from '../../../services/usuario.service';

// Tier 6: column-utils factory.
import { createActionColumn, createPlainColumn } from '../../../shared/components/kite-grid/column-utils/column-utils';

const pdfMakeAny: any = (pdfMake as any).default || pdfMake;
pdfMakeAny.vfs = (pdfFonts as any)?.pdfMake?.vfs || (pdfFonts as any)?.vfs || (pdfFonts as any)?.default || pdfFonts;

@Component({
    selector: 'app-oil-recovery',
    templateUrl: './oil-recovery.component.html',
    styleUrls: ['./oil-recovery.component.scss'],
    styles: ['.kite-modal-content{width: 60% !important;}'],
    standalone: false
})
export class OilRecoveryComponent implements OnInit {

  @ViewChild('input', { static: true }) input: ElementRef;
  // Tier 6: removed `@ViewChild('flex') flex: wjcGrid.FlexGrid` and
  // `@ViewChild('editOilRecoveryModal') editOilRecoveryModal: wjcInput.Popup`.
  // The wrapper owns the grid DOM; modal refs come from NgbModal `result.then`.

  @ViewChild('infoModal', { static: true }) infoModal!: TemplateRef<NgbModal>;
  @ViewChild('newOilRecoveryModal', { static: true }) newOilRecoveryModal!: TemplateRef<NgbModal>;
  @ViewChild('deleteModal', { static: true }) deleteModal!: TemplateRef<NgbModal>;


  oilRecoveryForm!: UntypedFormGroup;
  message = '';
  datos_arr_Tmp: any[] = [];
  datos_arr: any[] = [];
  // Tier 6: `pagination_arr` is now a plain array (was: CollectionView).
  pagination_arr: any[] = [];
  formSubmitted = false;
  titulo: boolean = true;
  resultCalculateWaste: number;

  oilRecovery: OilRecoveryModel;

  pdfUtilities: PdfUtilities = new PdfUtilities();
  calculatesWate: Calculates = new Calculates();
  files_arr: File[] = [];

  totalRecords: number = 0;

  // Tier 6: 3 action buttons (info, delete, pdf) → createActionColumn.
  // The legacy `CellMaker.makeButton` returned button templates with click
  // handlers; the AG Grid migration uses class-based delegation via
  // `(cellClicked)`.
  columnDefs: any[] = [];

  constructor(
    private fb: UntypedFormBuilder,
    private modalService: NgbModal,
    private toastr: ToastrService,
    private usuarioService: UsuarioService,
    private oilRecoveryService: OilRecoveryService,
    private clientsService: ClientsService,
    private zapierService: ZapierService
  ) { }

  ngOnInit(): void {
    this.cargarDatos();
    this.crearFormularioOilRecovery(null, 'new');
    this.buildColumnDefs();
  }

  /** Tier 6: build the column defs once. Three action buttons + 4 data
   *  columns. The legacy HTML had the dates column with `| date:'MMM d, y'`;
   *  the factory's dateRenderer supports the 'MMM d, y' format string. */
  private buildColumnDefs(): void {
    this.columnDefs = [
      createActionColumn({
        width: 130,
        buttons: [
          { icon: 'fa-info', title: 'Info', ariaLabel: 'info', classes: 'info-btn' },
          { icon: 'fa-trash', title: 'Delete', ariaLabel: 'delete', classes: 'delete-btn' },
          { icon: 'fa-file-pdf-o', title: 'PDF', ariaLabel: 'pdf', classes: 'pdf-btn' }
        ]
      }),
      createPlainColumn({ field: 'ident_GUI',       headerName: 'BUSINESS ID',  flex: 1, cellClass: 'ag-cell-center' }),
      createPlainColumn({ field: 'name_oilrecovery', headerName: 'NAME',         flex: 1, cellClass: 'ag-cell-center' }),
      createPlainColumn({ field: 'date_registered', headerName: 'DATE',         flex: 1, cellClass: 'ag-cell-center' }),
      createPlainColumn({ field: 'gal_collected',   headerName: 'GALLONS',      flex: 1, cellClass: 'ag-cell-center' }),
      createPlainColumn({ field: 'collected_by',    headerName: 'COLLECTED BY', flex: 1, cellClass: 'ag-cell-center' })
    ];
  }

  async cargarDatos() {
    this.message = '';
    try {
      const resp: any = await this.oilRecoveryService.getAllAsync();
      if (resp.oilrecoveries) {
        this.datos_arr_Tmp = resp.oilrecoveries;
      } else {
        this.datos_arr_Tmp = [];
        this.datos_arr = [];
        setTimeout(() => { this.message = 'No Data'; }, 500);
      }
      setTimeout(() => { this.message = resp.msg; }, 500);
    } catch (err) {
      this.datos_arr_Tmp = [];
      this.datos_arr = [];
      this.message = 'Error';
    }

    if (this.datos_arr_Tmp.length > 0) {
      const arr = [...this.datos_arr_Tmp];
      this.initGrid(this.toCollection(arr));
    }
  }

  /** Tier 6: replaces the legacy `_getData(arr)` which returned a
   *  CollectionView. Now returns a plain array; the wrapper owns
   *  pagination via `[totalRecords]` and `[rowData]`. */
  private toCollection(arr: any[]): any[] {
    const data: any[] = [];
    for (const item of arr) {
      const obj = { ...item, ident_GUI: item.client?.ident_GUI };
      data.push(obj);
    }
    // Sort by `date_registered` DESC — matches the legacy
    // `sortDescriptions.push(new SortDescription('date_registered', false))`.
    return data.slice().sort((a, b) => {
      const av = a.date_registered ? new Date(a.date_registered).getTime() : 0;
      const bv = b.date_registered ? new Date(b.date_registered).getTime() : 0;
      return bv - av;
    });
  }

  initGrid(data: any[]) {
    this.pagination_arr = data;
    this.totalRecords = data.length;
  }

  // =============================
  // Acciones de grilla — routed by `(cellClicked)`.
  // =============================
  onCellClicked(event: any): void {
    const target = event?.event?.target as HTMLElement | undefined;
    const btn = target?.closest('button');
    if (!btn) return;
    const row = event.data;
    if (!row) return;

    if (btn.classList.contains('info-btn')) {
      this.open(this.infoModal, 'xl', row);
    } else if (btn.classList.contains('delete-btn')) {
      this.open(this.deleteModal, 'xl', row);
    } else if (btn.classList.contains('pdf-btn')) {
      this.getPDF_File_Download(row);
    }
  }

  save() {
    // Tier 6: replaces `wjcGridXlsx.FlexGridXlsxConverter.saveAsync(this.flex, ...)`.
    // The XLSX backend endpoint is pending a future tier; for now we surface
    // a feedback info to the user.
    this.toastr.info('Excel export is pending a backend endpoint');
  }

  filterByGui(inputValue: string) {
    if (!inputValue) {
      return this.toastr.error('Invalid Project ID');
    }
    this.clientsService.getbygui(inputValue.toUpperCase().trim()).subscribe((res: any) => {
      if (this.input) this.input.nativeElement.value = '';
      if (!res.client) {
        return this.toastr.error('No Project ID found');
      }
      this.crearFormularioOilRecovery(res, 'new');
      this.open(this.newOilRecoveryModal, 'xl', null);
    });
  }

  open(content: TemplateRef<NgbModal>, size: string, data: any) {
    this.oilRecovery = data;
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', size });
  }

  crearFormularioOilRecovery(data?: OilRecoveryModel, accion?: string) {
    if (accion == 'edit') {
      this.oilRecoveryForm = this.fb.group({
        _id:             [data ? data._id : '', Validators.required],
        ident_GUI:       [data ? data.ident_GUI : '', Validators.required],
        name_oilrecovery: data ? data.client?.name_client_address : '',
        city:             data ? data.client?.city : '',
        address:          data ? data.client?.address : '',
        zip_code:         data ? data.client?.zip_code : '',
        citysel:          data ? data.client?.citysel?.county_name : '',
        date_registered:  [data ? data.date_registered : '', Validators.required],
        gal_collected:    [data ? data.gal_collected : '', Validators.required],
        delivery_by:      [data ? data.delivery_by : '', Validators.required],
        collected_by:     [data ? data.collected_by : '', Validators.required],
      });
    } else {
      this.oilRecoveryForm = this.fb.group({
        ident_GUI:       [data ? data.client?.ident_GUI : ''],
        name_oilrecovery: data ? data.client?.name_client_address : '',
        city:             data ? data.client?.city : '',
        address:          data ? data.client?.address : '',
        zip_code:         data ? data.client?.zip_code : '',
        citysel:          data ? data.client?.citysel?.county_name : '',
        date_registered:  ['', Validators.required],
        gal_collected:    ['', Validators.required],
        delivery_by:      ['', Validators.required],
        collected_by:     ['', Validators.required],
        client:           data ? data.client : ''
      });
    }
  }

  get date_registered() { return this.oilRecoveryForm.get('date_registered'); }
  get gal_collected()   { return this.oilRecoveryForm.get('gal_collected'); }
  get delivery_by()     { return this.oilRecoveryForm.get('delivery_by'); }
  get collected_by()    { return this.oilRecoveryForm.get('collected_by'); }

  newRegister(modal: any) {
    this.formSubmitted = true;
    if (!this.usuarioService.usuario.signature) {
      return this.toastr.error('User Signature missing');
    }
    if (this.oilRecoveryForm.valid) {
      const yy = new Date().getFullYear().toString().slice(-2);
      const updatedModelUtilities = new UpdatedModelUtilities(this.oilRecoveryService);
      const seqer = updatedModelUtilities.serial_maker();
      seqer.set_prefix('OR-');
      seqer.set_seq((Number(yy) * 10000) + 1 + this.datos_arr_Tmp.length);
      const _ident = `${seqer.gensym()}`;

      this.oilRecoveryForm.get('ident_GUI').setValue(_ident);
      this.gal_collected?.setValue(this.resultCalculateWaste);
      this.oilRecoveryService.create(this.oilRecoveryForm.value).subscribe(res => {
        modal.close();
        this.toastr.success(res.msg);
        this.formSubmitted = false;
        this.cargarDatos();
        this.getPDF_File(res.oilrecovery);
      });
    }
  }

  /** Replaces `updatedRegister(popup: wjcInput.Popup)`. The modal ref now
   *  comes from NgbModal's `result.then` callback upstream. */
  updatedRegister(popup: any) {
    this.formSubmitted = true;
    if (this.oilRecoveryForm.valid) {
      this.gal_collected?.setValue(this.resultCalculateWaste);
      this.oilRecoveryService.update(this.oilRecoveryForm.value, this.oilRecoveryForm.value._id).subscribe(res => {
        console.log(res);
        popup.hide();
        this.toastr.success(res.msg);
        this.formSubmitted = false;
        this.cargarDatos();
      });
    }
  }

  deleteOilRecovery(modal: any, _oilRecovery: OilRecoveryModel) {
    this.oilRecoveryService.delete(_oilRecovery._id).subscribe({
      next: res => {
        this.cargarDatos();
        this.toastr.success(res.msg);
        modal.close();
      },
      error: err => {
        console.log(err);
        this.toastr.error('Error');
      }
    });
  }

  closeModal(modal: any) {
    this.titulo = true;
    this.formSubmitted = false;
    modal.close();
  }

  getPDF_File(_oilRecovery: OilRecoveryModel) {
    const min = 1718;
    const max = 34290;
    const x = Math.floor(Math.random() * (max - min + 1) + min);
    const pdf = this.pdfUtilities.downloadPDFOilRecovery(x, _oilRecovery, this.usuarioService.usuario.signature);
    this.toSendPDF(pdf, _oilRecovery);
  }

  getPDF_File_Download(_oilRecovery: OilRecoveryModel) {
    const min = 1718;
    const max = 34290;
    const x = Math.floor(Math.random() * (max - min + 1) + min);
    const pdf = this.pdfUtilities.downloadPDFOilRecovery(x, _oilRecovery, this.usuarioService.usuario.signature);
    pdfMake.createPdf(pdf).download(`${_oilRecovery.client.ident_GUI}`);
  }

  public toSendPDF(pdf: any, _oilrecovery: OilRecoveryModel) {
    const pdfDocGenerator = pdfMake.createPdf(pdf);
    pdfDocGenerator.getBlob((document: any) => {
      const file = new File([document], `${_oilrecovery.client.ident_GUI}.pdf`, {
        type: 'application/pdf',
      });
      this.files_arr.push(file);
      this.setEmailData(_oilrecovery.client.email);
    });
  }

  async setEmailData(_clientEmail: string) {
    const _emails: string[] = [_clientEmail];

    await this.usuarioService.getAllAsync()
      .then((resp: any) => {
        if (resp.users) {
          resp.users.forEach((user: any) => {
            if (user.role === 'SALESMAN_ROLE' || user.role === 'SERVMAN_ROLE') {
              _emails.push(user.email);
            }
          });
          this.sendingEmail(_emails.join());
        }
      });
  }

  sendingEmail(_emails: string) {
    const json = {
      email: _emails,
      bodyHtml: EmailTemplate.HTML_BODY_OilRecovery,
      attachment: _emails
    };
    this.zapierService.sentEmail(_emails, json.bodyHtml, this.files_arr)
      .subscribe({
        next: resp => {
          console.log(resp);
          this.toastr.info('Sent Email');
        },
        error: err => {
          console.log(err);
          this.toastr.error('Email Error');
        }
      });
  }

  calcularWaste(valor: any) {
    this.resultCalculateWaste = this.calculatesWate.calculateWaste(parseInt(valor));
  }
}
